module.exports = __webpack_public_path__ + "img/events.804e9ba3.svg";